import { Tooltip, ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid } from "recharts";
import { CalendarRange } from "lucide-react";
import { useContext } from "react";
import { DashboardContext } from "../context/DashboardContext";
import { formatterCurrency } from "../../../shared/utils";


export default function GraphicDailySales() {

    const { data } = useContext(DashboardContext);
    const series = data.resumo_diario || [];


    return (
        <div className="surface-card surface-card-hover p-6">
            <div className="flex items-center justify-between mb-5">
                <div className="flex items-center gap-2">
                    <span className="h-8 w-8 rounded-lg bg-positive-500/15 ring-1 ring-positive-500/25 grid place-items-center">
                        <CalendarRange className="h-4 w-4 text-positive-400" />
                    </span>
                    <div>
                        <h3 className="heading-3">Receita líquida vs tráfego por dia</h3>
                        <p className="text-xs text-ink-4">Quantidade de vendas, valor líquido recebido e investimento em ads</p>
                    </div>
                </div>
                <div className="flex items-center gap-3 text-xs text-ink-3">
                    <span className="inline-flex items-center gap-1.5">
                        <span className="h-2.5 w-2.5 rounded-sm bg-brand-500" /> Quantidade
                    </span>
                    <span className="inline-flex items-center gap-1.5">
                        <span className="h-2.5 w-2.5 rounded-sm bg-positive-500" /> Líquido
                    </span>
                    <span className="inline-flex items-center gap-1.5">
                        <span className="h-2.5 w-2.5 rounded-sm bg-warning-500" /> Tráfego
                    </span>
                </div>
            </div>

            <ResponsiveContainer width="100%" height={300}>
                <BarChart data={series} margin={{ top: 10, right: 16, left: 0, bottom: 0 }}>
                    <defs>
                        <linearGradient id="barBrand" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="0%" stopColor="#818CF8" stopOpacity={1} />
                            <stop offset="100%" stopColor="#4F46E5" stopOpacity={0.85} />
                        </linearGradient>
                        <linearGradient id="barPositive" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="0%" stopColor="#34D399" stopOpacity={1} />
                            <stop offset="100%" stopColor="#059669" stopOpacity={0.85} />
                        </linearGradient>
                        <linearGradient id="barWarning" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="0%" stopColor="#FBBF24" stopOpacity={1} />
                            <stop offset="100%" stopColor="#D97706" stopOpacity={0.85} />
                        </linearGradient>
                    </defs>
                    <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.06)" vertical={false} />
                    <XAxis
                        dataKey="dia"
                        stroke="#71717A"
                        fontSize={11}
                        tickLine={false}
                        axisLine={{ stroke: 'rgba(255,255,255,0.06)' }}
                    />
                    <YAxis
                        yAxisId="qtd"
                        stroke="#71717A"
                        fontSize={11}
                        tickLine={false}
                        axisLine={false}
                    />
                    <YAxis
                        yAxisId="rs"
                        orientation="right"
                        stroke="#71717A"
                        fontSize={11}
                        tickLine={false}
                        axisLine={false}
                        tickFormatter={(v) => v >= 1000 ? `${(v / 1000).toFixed(1)}k` : v}
                    />
                    <Tooltip
                        cursor={{ fill: 'rgba(99,102,241,0.06)' }}
                        contentStyle={{
                            background: '#15151A',
                            border: '1px solid rgba(255,255,255,0.08)',
                            borderRadius: '12px',
                            boxShadow: '0 8px 24px -12px rgba(0,0,0,0.6)',
                            color: '#FAFAFA',
                            fontSize: '13px',
                        }}
                        labelStyle={{ color: '#A1A1AA', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.08em' }}
                        formatter={(value, name) => {
                            if (name === 'Quantidade') return [`${value} vendas`, name];
                            return [formatterCurrency(value), name];
                        }}
                    />
                    <Bar yAxisId="qtd" dataKey="quantidade"     fill="url(#barBrand)"    name="Quantidade" radius={[6, 6, 0, 0]} />
                    <Bar yAxisId="rs"  dataKey="valor_produtor" fill="url(#barPositive)" name="Líquido"    radius={[6, 6, 0, 0]} />
                    <Bar yAxisId="rs"  dataKey="investido"      fill="url(#barWarning)"  name="Tráfego"    radius={[6, 6, 0, 0]} />
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
}
